/** Isolated route prefix — does not replace production Django URLs. */
export const CLASSIC_SITE_BASE = "/classic-site";

export const SURFACE_STATUS = {
  DONE: "done",
  PARTIAL: "partial",
  SHELL: "shell",
  BLOCKED: "blocked",
  HYBRID: "hybrid",
  NA: "na",
};

/** Django auth URLs (django-allauth + classic_site). */
export const DJANGO_AUTH_URLS = {
  login: "/accounts/login/",
  signup: "/accounts/signup/",
  logout: "/accounts/logout/",
  authChoose: "/accounts/auth/choose/",
};

/** Django member URLs (reference for hybrid links). */
export const DJANGO_MEMBER_URLS = {
  profile: "/member/accounts/profile/",
  subscriptions: "/member/accounts/subscriptions/",
  subscriptionChoose: "/member/accounts/subscriptions/choose/",
  listingsNew: "/member/listings/new/",
  login: DJANGO_AUTH_URLS.login,
  logout: "/member/accounts/logout/",
};

export const DJANGO_ADMIN_URL = "/admin/";

/** Admin models from classic_site/admin.py — for nav and shells. */
export const ADMIN_MODELS = [
  {
    slug: "users",
    label: "Users",
    djangoModel: "auth.User",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "subscription-users",
    label: "Subscription Users",
    djangoModel: "classic_site.SubscriptionUser",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "members",
    label: "Members",
    djangoModel: "classic_site.Member",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "phone-numbers",
    label: "Phone Numbers",
    djangoModel: "classic_site.PhoneNumber",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "listings",
    label: "Directory Entries",
    djangoModel: "classic_site.DirectoryEntry",
    status: SURFACE_STATUS.PARTIAL,
    adminToolsPath: "/admin-tools/listings",
  },
  {
    slug: "events",
    label: "Listing Events",
    djangoModel: "classic_site.ListingEvent",
    status: SURFACE_STATUS.SHELL,
  },
  {
    slug: "promos",
    label: "Listing Promotions",
    djangoModel: "classic_site.ListingPromotion",
    status: SURFACE_STATUS.SHELL,
  },
  {
    slug: "tags",
    label: "Listing Tags",
    djangoModel: "classic_site.ListingTag",
    status: SURFACE_STATUS.SHELL,
  },
  {
    slug: "tag-groupings",
    label: "Tag Groupings",
    djangoModel: "classic_site.TagGrouping",
    status: SURFACE_STATUS.SHELL,
  },
  {
    slug: "social-groups",
    label: "Facebook Groups",
    djangoModel: "classic_site.FacebookGroup",
    status: SURFACE_STATUS.SHELL,
  },
  {
    slug: "coupons",
    label: "Fast Track Coupons",
    djangoModel: "classic_site.FastTrackCouponCode",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "announcements",
    label: "Site Announcements",
    djangoModel: "classic_site.SiteAnnouncement",
    status: SURFACE_STATUS.BLOCKED,
  },
  {
    slug: "listing-flags",
    label: "Listing Flags",
    djangoModel: "classic_site.ListingFlag",
    status: SURFACE_STATUS.BLOCKED,
  },
];
